// extracted by mini-css-extract-plugin
export default {"wrap":"gift-card-view_wrap__4XwiP","titlebar":"gift-card-view_titlebar__ZwVyD","title":"gift-card-view_title__8zDaK","gift-card":"gift-card-view_gift-card__nOwbI"};